var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOpenBin = function SvgOpenBin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20.97 28.7"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".open-bin_svg__cls-1{fill:none;stroke:#58595b;stroke-linecap:round;stroke-linejoin:round}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "open-bin_svg__Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "open-bin_svg__Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "open-bin_svg__Shape_1471",
    d: "m.5.88 20 6.48",
    className: "open-bin_svg__cls-1",
    "data-name": "Shape 1471"
  }), /*#__PURE__*/React.createElement("path", {
    id: "open-bin_svg__Shape_1472",
    d: "M13.55 2 9.27.57a1.51 1.51 0 0 0-1.89 1L6.92 3l7.13 2.32.47-1.43A1.51 1.51 0 0 0 13.55 2",
    className: "open-bin_svg__cls-1",
    "data-name": "Shape 1472"
  }), /*#__PURE__*/React.createElement("path", {
    id: "open-bin_svg__Shape_1473",
    d: "M6.7 23v-7.5",
    className: "open-bin_svg__cls-1",
    "data-name": "Shape 1473"
  }), /*#__PURE__*/React.createElement("path", {
    id: "open-bin_svg__Shape_1474",
    d: "M11.2 23v-7.5",
    className: "open-bin_svg__cls-1",
    "data-name": "Shape 1474"
  }), /*#__PURE__*/React.createElement("path", {
    id: "open-bin_svg__Shape_1475",
    d: "M15.82 26.82a1.51 1.51 0 0 1-1.5 1.38H3.58a1.49 1.49 0 0 1-1.49-1.38L.7 10.2h16.5Z",
    className: "open-bin_svg__cls-1",
    "data-name": "Shape 1475"
  })))));
};
export default SvgOpenBin;